// @flow

export default {
  logo: {
    maxWidth: 200,
    maxHeight: 70,
  },
};
